<template>
  <div class="container-types">
    <div v-for="typeItem in typeItems" :key="typeItem.id" class="type-container">
      <div class="main-box">
        <div class="wrapper-box">
          <div
            :aria-checked="typeItem.visible"
            class="wrapper-box-checkbox checkbox"
            role="checkbox"
            tabindex="0"
            @click="emitId(typeItem.id, typeItem.visible)"
            @keydown.space="(event) => handleSpaceKey(event, typeItem.id, typeItem.visible)"
          >
            <label :for="typeItem.id" class="checkbox__label" />
            <input :id="typeItem.id" :checked="typeItem.visible" tabindex="-1" type="checkbox" />
            <span :for="typeItem.id" class="checkmark" />
          </div>
          <div class="wrapper-box-label" :style="typeItem.color ? 'max-width: 80%' : ''">
            <span class="label-select">{{ typeItem.name }}</span>
          </div>
          <div v-if="typeItem.color" class="wrapper-box-circle">
            <span class="circle" :style="{ backgroundColor: typeItem.color }"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TypeItem } from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import { toRefs } from 'vue'

interface EMITS {
  (e: 'emitId', id: string, checked: boolean)
}
const emits = defineEmits<EMITS>()
interface PROPS {
  typeItems: TypeItem[]
}
const props = defineProps<PROPS>()
const { typeItems } = toRefs(props)
function emitId(id: string, checked: boolean) {
  checked = !checked
  emits('emitId', id, checked)
}
function handleSpaceKey(event: KeyboardEvent, id: string, visible: boolean) {
  event.preventDefault()
  emitId(id, visible)
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/mixins.scss';
@use '@/styles/variables.scss';
.circle {
  border: 1px solid variables.$color-grey-darker;
  border-radius: 50%;
  display: block;
  height: 16px;
  min-width: 16px;
  width: 16px;
}
.label-select {
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 400;
}
.wrapper-box {
  display: inline-block;
  width: 100%;
  &-checkbox {
    float: left;
    width: 16px;
    height: 16px;
    background: #f8f8f8;
    box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    position: relative;
    transition: background-color 0.4s;
    cursor: pointer;
  }
  &-circle {
    float: right;
  }
  &-label {
    float: left;
    max-width: 90%;
    word-break: break-all;
  }
}
.container-types {
  height: 200px;
  overflow-y: auto;
  white-space: pre-line;
  @include mixins.scrollbar-vertical;
}
.type-container {
  padding-right: 8px;
}
.main-box {
  padding-left: 20px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.main-box input {
  opacity: 0;
  cursor: pointer;
  height: 0;
}
.checkmark {
  cursor: pointer;
  width: 100%;
}
.checkbox .checkmark:after {
  content: '';
  position: absolute;
  width: 4px;
  height: 9px;
  border-right: 2px solid #353b40;
  border-bottom: 2px solid #353b40;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(4);
  transition: all 0.4s;
  opacity: 0;
  pointer-events: none;
}
.checkbox input:checked ~ .checkmark:after {
  opacity: 1;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
}
.checkbox input:checked ~ .checkmark {
  background-color: variables.$color-grey-lighter;
}
@media screen and (max-width: 1024px) {
  .main-box {
    padding: 0;
  }
  .container-types {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    min-height: 200px;
    overflow: unset;
  }
  .type-container {
    padding-right: 0;
  }
  .label-select {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 21px;
  }

  .wrapper-box {
    padding-right: 10px;
  }
  .wrapper-box-checkbox {
    width: 24px;
    height: 24px;
  }
  .checkbox .checkmark:after {
    width: 8px;
    height: 20px;
  }
  .circle {
    border: 1px solid variables.$color-white-70;
    margin-top: 4px;
  }
}
</style>
